var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#F7F9FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 17.6403V19.6667C8 19.8534 8.14665 20 8.33329 20H10.3597C10.4463 20 10.533 19.9667 10.593 19.9L17.872 12.6277L15.3723 10.128L8.09999 17.4004C8.03333 17.467 8 17.547 8 17.6403ZM19.805 10.6946C20.065 10.4347 20.065 10.0147 19.805 9.75476L18.2452 8.19497C17.9853 7.93501 17.5653 7.93501 17.3054 8.19497L16.0855 9.4148L18.5852 11.9145L19.805 10.6946Z",
    fill: "#3A4669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.67bb1da1e10ea4f24e6b9da733afa473.svg";
export { ForwardRef as ReactComponent };